class MoonCalculatorPicker extends HTMLElement {
  constructor() {
    super()
    this.pickerModal = this.querySelector('.modal-picker')
    this.selectedImage = this.querySelector('.selected-image');
  }

  dispatchUpdate() {
    const event = new CustomEvent('calendar:updated', {
      detail: {
        element: this.input.value,
        index: this.index
      }
    });
    document.dispatchEvent(event);
  }

  updateInputValue(a,b) {
    this.input.value = `${a} / ${b}`
  }
  
  setCurrentSelection(target) {
    const allOptions = this.querySelectorAll('.picker-option')
    allOptions?.forEach(option => {
      option.classList.remove('current')
    })
    target.parentElement.classList.add('current')
  }

  closePickerModals() {
    const pickerModals = document.querySelectorAll('.modal-picker');
    pickerModals.forEach(modal => {
      if (modal.classList.contains('active') && modal !== this.pickerModal) {
        modal.classList.remove('active')
      }
    })
  }

  openModal() {
    this.closePickerModals()
    this.pickerModal.classList.add('active')
    document.body.classList.add('modal-picker-open')
  }

  closeModal() {
    this.pickerModal.classList.remove('active')
    document.body.classList.remove('modal-picker-open')
  }
}

// -------------------------------------
// MOON CALCULATOR
// -------------------------------------
class MoonPhasePicker extends MoonCalculatorPicker {
  constructor() {
    super();
    this.moonPhaseFinder = this.closest('moon-phase-finder');
    this.pickerModal = this.moonPhaseFinder.querySelector('.modal-picker')
    this.moonPhaseLabel = this.moonPhaseFinder.querySelector('.moon-phase-label');
    this.datepickerGroups = this.moonPhaseFinder.querySelectorAll('.datepicker-options')
    this.datepickerDays = this.moonPhaseFinder.querySelectorAll('.datepicker-options--day > label')
    this.datepickerToggles = this.moonPhaseFinder.querySelectorAll('.datepicker-toggle')
    this.datepickerPanels = this.moonPhaseFinder.querySelectorAll('.datepicker-panel')
    this.datePickerEdit = this.moonPhaseFinder.querySelectorAll('.datepicker-edit');
    this.dateInput = this.moonPhaseFinder.querySelector('.date-picker');
    this.closeButton = this.moonPhaseFinder.querySelector('.close');
    this.dateRow = this.moonPhaseFinder.querySelector('.datepicker-container.moon-calculator__step-row');
    this.colorRow = this.moonPhaseFinder.querySelector('.colorpicker-container.moon-calculator__step-row');
    this.index = this.moonPhaseFinder.dataset.index;
    this.input = document.querySelector(`#select-moon-phase-data-${this.index}`);
    this.moonPhaseColors = this.querySelectorAll('.picker-option');
    this.dateSelectedEvent = `dateSelected-${this.dateInput.dataset.instance}`;
    
    this.setDefaultColor(this.selectedImage);
    this.handleEvents();
  }

  handleEvents() {
    this.moonPhaseColors.forEach(el => 
      el.addEventListener('click', (e) => 
        this.updateMoonColor(el) 
      )
    )
    this.datePickerEdit.forEach(el => 
      el.addEventListener('click', (e) => 
        this.openModal()
      )
    )

    this.closeButton.addEventListener('click', (e) => 
      this.closeModal()
    )

    document.addEventListener(this.dateSelectedEvent, async (e) => {
      const date = e.detail.date;
      const moonPhase = await MoonCalculator.fetchCalendarData(date);
      const moonPhaseName = MoonCalculator.getMoonPhaseName(moonPhase);
      const color = this.querySelector('.selected-image').dataset.color;
      const zeroPad = (num, places) => String(num).padStart(places, '0');

      this.day = Number(date.split('-')[0]);
      this.dayPadded = zeroPad(Number(date.split('-')[0]), 2);
      this.month = Number(date.split('-')[1]);
      this.monthPadded = zeroPad(Number(date.split('-')[1]), 2);
      this.year = Number(date.split('-')[2]);
      this.animal = this.getZodiacAnimal(this.year);
      this.moonCode = moonPhase;

      const dateObj = new Date(`${this.year}-${this.monthPadded}-${this.dayPadded}`);
      const dayNames = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
      this.weekday = dayNames[dateObj.getDay()];

      this.updateImages(moonPhase);
      this.updateMoonPhaseName(moonPhaseName, this.moonPhaseFinder);
      this.updateInputValue(moonPhaseName, color);
      this.toggleDateRowValidation(true)
      this.dispatchUpdate();
    });

    this.datepickerToggles?.forEach(toggle => {
      const isPdpForm = toggle.classList.contains('datepicker-edit')
      toggle.addEventListener('click', (e) => {
        const unselectedGroups = this.getUnselectedGroups()
        // if there are unselected groups, open the first one
        if (isPdpForm && unselectedGroups.length) this.toggleDatepickerPanel(unselectedGroups[0])
        // otherwise go to the one indicated by the toggle
        else this.toggleDatepickerPanel(parseInt(toggle.dataset.toggle))
      })
    })
    this.datepickerGroups?.forEach(group => {
      const radios = group.querySelectorAll('input[type=radio]')
      radios?.forEach(radio => {
        radio.addEventListener('change', (e) => {
          this.onDatePieceSelected(radio, group.parentElement.dataset.index, group.dataset.option)
        })
      })
    })
  }

  getZodiacAnimal(year) {
    const animals = ["Rat", "Ox", "Tiger", "Rabbit", "Dragon", "Snake", "Horse", "Goat", "Monkey", "Rooster", "Dog", "Pig"];
    if (isNaN(year)) return "Unknown";
    return animals[(year - 1900) % 12] || "Unknown";
  }

  toggleDateRowValidation(valid) {
    if (valid) {
      this.dateRow.setAttribute('data-empty-step', false)
      this.dateRow.classList.remove('has-error')
      this.dateInput.classList.add('filled');
    }
    else {
      this.dateRow.setAttribute('data-empty-step', true)
      this.dateInput.classList.remove('filled');
    }
  }

  getUnselectedGroups() {
    let unselectedGroups = []
    this.datepickerGroups?.forEach((group, i) => {
      let isUnselected = true
      group.querySelectorAll('input[type=radio]').forEach(input => {
        if (input.checked) isUnselected = false
      })
      if (isUnselected) unselectedGroups.push(i + 1)
    })
    return unselectedGroups
  }

  onDateSelectionComplete() {
    const dateStr = this.formDateString()
    this.dateInput.value = dateStr
    let customEvent = new CustomEvent(this.dateSelectedEvent, {
      detail: {
        date: dateStr,
        index: this.moonPhaseFinder.dataset.index
      }
    })
    document.dispatchEvent(customEvent)
  }

  formDateString() {
    // "20-1-2025" dateFormat: "d-n-Y"
    let dateStr = ''
    this.datepickerGroups?.forEach((group, i) => {
      const checkedInput = group.querySelector('input[type=radio]:checked')
      if (checkedInput) {
        dateStr = dateStr + checkedInput.dataset.date
        if (i <= 1) dateStr = dateStr + '-'
      }
      else return
    })
    return dateStr
  }

  disableCalendarDays(days) {
    this.datepickerDays?.forEach(dayEl => {
      const dayInput = dayEl.querySelector('input')
      if (days.includes(dayInput.value)) {
        dayInput.checked = false
        dayEl.setAttribute('disabled', true)
        dayEl.classList.add('hidden')
      }
      else {
        dayEl.removeAttribute('disabled')
        dayEl.classList.remove('hidden')
      }
    })
  }

  updateOptionDisplays() {
    this.datepickerGroups?.forEach((group, i) => {
      const selectedInput = group.querySelector('input:checked')
      if (selectedInput) {
        this.moonPhaseFinder.querySelectorAll(`.datepicker-toggle[data-option=${group.dataset.option}]`).forEach(display => {
          display.innerHTML = selectedInput.value
          display.classList.add('active')
        })
      }
      else {
        this.moonPhaseFinder.querySelectorAll(`.datepicker-toggle[data-option=${group.dataset.option}]`).forEach(display => {
          display.innerHTML = group.dataset.option
          display.classList.remove('active')
        })
      }
    })
  }

  onDatePieceSelected(radio, panelIndex, option) {
    // disable relevant days to months
    if (option === 'Month') {
      switch (radio.dataset.date) {
        case '2':
          this.disableCalendarDays(['29','30','31'])
          break
        case '4':
        case '6':
        case '9':
        case '11':
          this.disableCalendarDays(['31'])
          break
        default:
          this.disableCalendarDays([])
      }
    }

    this.updateOptionDisplays()

    // advance to next panel if relevant
    if (parseInt(panelIndex) <= 2) this.toggleDatepickerPanel(parseInt(panelIndex) + 1)
    else this.closeModal()

    // if the date pieces are completed..
    if (!this.getUnselectedGroups().length) {
      this.onDateSelectionComplete()
    }
    // reset the validation
    else {
      this.toggleDateRowValidation(false)
      this.dispatchUpdate();
    }
  }

  toggleDatepickerPanel(index) {
    // set active panel
    this.datepickerPanels?.forEach(panel => {
      const thisIndex = parseInt(panel.dataset.index)
      if (thisIndex === index) panel.classList.add('active')
      else panel.classList.remove('active')
    })
    // active class for toggle button
    this.datepickerToggles?.forEach(toggle => {
      if (toggle.classList.contains('datepicker-edit')) return
      if (parseInt(toggle.dataset.toggle) === index) toggle.classList.add('active')
      else toggle.classList.remove('active')
    })
  }

  setCurrentSelection(el) {
    const allOptions = this.querySelectorAll('.picker-option')
    allOptions?.forEach(option => {
      option.classList.remove('selected-image')
      option.querySelector('.picker-swatch')?.classList.remove('active')
    })
    el.classList.add('selected-image')
    el.querySelector('.picker-swatch')?.classList.add('active')
  }

  updateInputValue(moonPhaseName, color) {
    color = color ? color : 'Natural';
    const monthName = MoonCalculator.getMonthName(this.month);
    // PhaseName / DMY / Color / MoonCode / Weekday / Animal
    this.input.value = `${moonPhaseName} / ${this.day} ${monthName} ${this.year} / ${color} / ${this.moonCode} / ${this.weekday} / ${this.animal}`;
  }

  updateMoonPhaseName(name) {
    this.moonPhaseLabel.classList.add('active')
    this.moonPhaseLabel.querySelector('.moon-phase-label__prefix').innerText = 'Your Moon Phase Is:'
    this.moonPhaseLabel.querySelector('.moon-phase-label__name').innerText = name;
  }

  updateInputColor(color) {
    const value = this.input.value.split(' / ');
    value[2] = color;
    this.input.value = value.join(' / ');
  }

  setDefaultColor(el) {
    this.updateMoonColor(el);
  }

  updateMoonColor(el) {
    this.setCurrentSelection(el);
    this.updateInputColor(el.dataset.color);
    this.colorRow.setAttribute('data-empty-step', false)
    this.colorRow.classList.remove('has-error')
    this.dispatchUpdate();
  }

  updateImages(moonPhase) {
    const picker_options = this.moonPhaseFinder.querySelectorAll('.picker-option');
    picker_options.forEach((option, i) => {
      const img = option.querySelector('img')
      const updatedSrc = this.updateImgUrl(option, moonPhase);
      img.src = updatedSrc;
    });
  }

  updateImgUrl(option, replacementCode) {
    const currentSrc = this.selectedImage.querySelector('img').src;
    const color = option.dataset.color;
    const parts = currentSrc.split('/');
    const lastPart = parts[parts.length - 1];
    const [prefix, suffix] = lastPart.split('_');
    const updatedPrefix = color === 'Blue' ? `P-${replacementCode}BL` : color === 'Green' ? `P-${replacementCode}GR` : `${replacementCode}`;
    const updatedFileName = `${updatedPrefix}_${suffix}`;
    parts[parts.length - 1] = updatedFileName;
    const updatedSrc = parts.join('/');
    return updatedSrc;
  }
}

if (!customElements.get('moon-phase-picker')) customElements.define('moon-phase-picker', MoonPhasePicker);

// -------------------------------------
// ELEMENT PICKER
// -------------------------------------
class ElementPicker extends MoonCalculatorPicker {
  constructor() {
    super();
    this.closeButton = this.querySelector('.close');
    this.stepRow = this.querySelector('[data-empty-step]')
    this.datePicker = this.querySelector('.date-picker');
    this.index = this.dataset.index;
    this.input = document.querySelector(`#select-element-data-${this.index}`);
    this.handleEvents.bind(this)();
  }

  handleEvents() {
    this.selectedImage.addEventListener('click', this.openModal.bind(this));
    this.closeButton.addEventListener('click', this.closeModal.bind(this));
    this.pickerModal.addEventListener('click', (e) => {
      if (e.target.tagName === 'IMG') {
        this.updateElement(e.target);
        this.dispatchUpdate();
      }
    });
    
    const dateSelectedEvent = this.datePicker ? `dateSelected-${this.datePicker.dataset.instance}` : 'dateSelected-moon-phase-finder--1';
    document.addEventListener(dateSelectedEvent, async (e) => {
      const date = e.detail.date; // "20-1-2025"
      const day = Number(date.split('-')[0]);
      const month = Number(date.split('-')[1]);
      const zodiacObj = MoonCalculator.getZodiacElementFromDate(day, month);
      this.updateElementFromDate(zodiacObj);
    });
  }

  updateElementFromDate(zodiacObj) {
    const elementName = this.querySelector('.element-name');
    this.updateInputValue(zodiacObj.zodiacSign, zodiacObj.element);
    elementName.innerHTML = `<span>${zodiacObj.zodiacSign}</span> | <span>${zodiacObj.element}</span>`;
    elementName.classList.remove('default');
    const targetImage = this.querySelector(`img[data-element="${zodiacObj.element}"][data-label="${zodiacObj.zodiacSign}"]`);
    this.updateElementImage(targetImage);
  };

  updateElementImage(targetImage) {
    this.setCurrentSelection(targetImage);
    const selectedImage = this.selectedImage.querySelector('img');
    selectedImage.src = targetImage.src;
    selectedImage.srcset = targetImage.srcset;
    selectedImage.alt = targetImage.alt;
    selectedImage.dataset.label = targetImage.dataset.label;
    selectedImage.dataset.element = targetImage.dataset.element;
    // Update empty-step attribute for validation
    this.stepRow?.classList.remove('has-error');
    this.stepRow?.setAttribute('data-empty-step', false);
  }

  updateElement(targetImage) {
    const elementName = this.querySelector('.element-name');
    const element = targetImage.dataset.element;
    const label = targetImage.dataset.label;

    this.updateInputValue(label, element);

    elementName.innerHTML = `<span>${label}</span> | <span>${element}</span>`;
    elementName.classList.remove('default');

    this.updateElementImage(targetImage);
    this.closeModal();
  }
}

if (!customElements.get('elements-picker')) customElements.define('elements-picker', ElementPicker);

// -------------------------------------
// BIRTHSTONE PICKER
// -------------------------------------
class BirthstonePicker extends MoonCalculatorPicker {
  constructor() {
    super();
    this.closeButton = this.querySelector('.close');
    this.stepRow = this.querySelector('[data-empty-step]')
    this.index = this.dataset.index;
    this.input = document.querySelector(`#select-birthstone-data-${this.index}`);
    this.handleEvents.bind(this)();
  }

  handleEvents() {
    this.selectedImage.addEventListener('click', this.openModal.bind(this));
    this.closeButton.addEventListener('click', this.closeModal.bind(this));
    this.pickerModal.addEventListener('click', (e) => {
      if (e.target.tagName === 'IMG') {
        this.updateBirthstone(e.target);
      }
      this.dispatchUpdate();
    });
    
    const dateSelectedEvent = 'dateSelected-moon-phase-finder--' + this.index;
    document.addEventListener(dateSelectedEvent, async (e) => {
      const date = e.detail.date; // "20-1-2025"
      const month = Number(date.split('-')[1]);
      const targetImg = this.querySelector(`img[data-month-index="${month}"]`);
      this.updateBirthstone(targetImg);
    });
  }

  updateBirthstone(targetImage) {
    const selectedImage = this.querySelector('.selected-image img');
    const birthstoneName = this.querySelector('.birthstone-name');
    const month = targetImage.dataset.month;
    const name = targetImage.dataset.name;
    this.setCurrentSelection(targetImage);
    this.updateInputValue(month,name);
    birthstoneName.textContent = `${name} | ${month}`;
    birthstoneName.classList.remove('default');

    selectedImage.src = targetImage.src;
    selectedImage.alt = targetImage.alt;
    selectedImage.dataset.name = name;
    selectedImage.dataset.month = month;

    this.stepRow?.setAttribute('data-empty-step', false);
    this.stepRow?.classList.remove('has-error');

    this.closeModal();
  }
}

if (!customElements.get('birthstone-picker')) customElements.define('birthstone-picker', BirthstonePicker);

// -------------------------------------
// ZODIAC PICKER
// -------------------------------------
class ZodiacPicker extends MoonCalculatorPicker {
  constructor() {
    super();
    this.closeButton = this.querySelector('.close');
    this.stepRow = this.querySelector('[data-empty-step]')
    this.index = this.dataset.index;
    this.input = document.querySelector(`#select-zodiac-data-${this.index}`)
    this.handleEvents.bind(this)()
  }

  getZodiacSymbol(dateString) {
    // Parse the date string (format: 'DD-MM-YYYY')
    const [day, month] = dateString.split('-').map(Number);
    const zodiacSigns = [
      { name: 'Capricorn', symbol: '♑', start: [12, 22], end: [1, 19] },
      { name: 'Aquarius', symbol: '♒', start: [1, 20], end: [2, 18] },
      { name: 'Pisces', symbol: '♓', start: [2, 19], end: [3, 20] },
      { name: 'Aries', symbol: '♈', start: [3, 21], end: [4, 19] },
      { name: 'Taurus', symbol: '♉', start: [4, 20], end: [5, 20] },
      { name: 'Gemini', symbol: '♊', start: [5, 21], end: [6, 20] },
      { name: 'Cancer', symbol: '♋', start: [6, 21], end: [7, 22] },
      { name: 'Leo', symbol: '♌', start: [7, 23], end: [8, 22] },
      { name: 'Virgo', symbol: '♍', start: [8, 23], end: [9, 22] },
      { name: 'Libra', symbol: '♎', start: [9, 23], end: [10, 22] },
      { name: 'Scorpio', symbol: '♏', start: [10, 23], end: [11, 21] },
      { name: 'Sagittarius', symbol: '♐', start: [11, 22], end: [12, 21] }
    ];
    for (const sign of zodiacSigns) {
      const [startMonth, startDay] = sign.start;
      const [endMonth, endDay] = sign.end;
      if (startMonth > endMonth) {
        if ((month === startMonth && day >= startDay) || 
            (month === endMonth && day <= endDay)) {
          return sign.name;
        }
      } else {
        if ((month === startMonth && day >= startDay) || 
            (month === endMonth && day <= endDay) ||
            (month > startMonth && month < endMonth)) {
          return sign.name;
        }
      }
    }
    return ''; 
  }

  handleEvents() {
    this.selectedImage.addEventListener('click', this.openModal.bind(this))
    this.closeButton.addEventListener('click', this.closeModal.bind(this))
    this.pickerModal.addEventListener('click', (e) => {
      if (e.target.tagName === 'IMG') this.updateZodiac(e.target)
      this.dispatchUpdate()
    })
    
    const dateSelectedEvent = 'dateSelected-moon-phase-finder--' + this.index
    document.addEventListener(dateSelectedEvent, async (e) => {
      const date = e.detail.date; // "20-1-2025"
      const sign = this.getZodiacSymbol(date)
      const targetImg = this.querySelector(`img[data-sign="${sign}"]`)
      this.updateZodiac(targetImg)
    })
  }

  updateZodiac(targetImage) {
    const selectedImage = this.querySelector('.selected-image img')
    const zodiacName = this.querySelector('.zodiac-name')
    const sign = targetImage.dataset.sign
    this.setCurrentSelection(targetImage)
    this.input.value = sign
    zodiacName.textContent = sign
    zodiacName.classList.remove('default')

    selectedImage.src = targetImage.src;
    selectedImage.alt = targetImage.alt;
    selectedImage.dataset.sign = sign;

    this.stepRow?.setAttribute('data-empty-step', false)
    this.stepRow?.classList.remove('has-error')
    this.closeModal()
  }
}

if (!customElements.get('zodiac-picker')) customElements.define('zodiac-picker', ZodiacPicker)